import Vue from 'vue'
import App from './App.vue'
import router from './router'
import FishUI from 'fish-ui'
import Vuex from 'vuex';
import axios from 'axios';
import { Form, DatePicker, Space, Collapse, Switch, BackTop, Spin, Modal, Tabs, Tooltip, Row, Col, Upload, Popconfirm, Radio, Popover, Checkbox, Progress, Pagination, Button, Drawer, Tag, Menu, Icon, Dropdown, Badge, Table, Input, InputNumber, Select } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import vueHeadful from 'vue-headful';
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-headful', vueHeadful);
import SKProgress from 'vue-multiple-progress'
Vue.use(SKProgress)
Vue.use(Popconfirm);
Vue.use(Space);
Vue.use(BackTop);
Vue.use(Switch);
Vue.use(Collapse);
Vue.use(Checkbox);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tooltip);
Vue.use(Upload);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Popover);
Vue.use(Form);
Vue.use(Drawer);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Menu);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Table);
Vue.use(Badge);
Vue.use(Dropdown);
Vue.use(Progress);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Vuex);
Vue.prototype.$PRJ_NAME = 'RCP1'
Vue.prototype.$PRJ_FULLNAME = 'THƯỞNG VỊ CỰC ÊM, TRÚNG QUÀ CỰC CHẤT'
Vue.prototype.$PRJ_DOMAIN = 'https://bia333pilsner.vn'
// axios.defaults.baseURL = 'http://sbc2.itcs.com.vn'//'http://sbc2.itcs.com.vn'//
const store = new Vuex.Store({
  state: {
    $message: null,
    oUser: {},
    isLogin: false,
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    Go_Route(path) {
      router.go(path)
    },

    API_GetInfo(context, data) {
      //console.log(context.state.oUser.Token)
      return new Promise((resolve, reject) => {
        // axios.get(Vue.prototype.$PRJ_DOMAIN+'/GetInfo/'+data)
        axios.get(Vue.prototype.$PRJ_DOMAIN+'/GetInfo/' + data)
          .then(function (response) {
            //console.log(response);
            resolve(response.data)
            //PROCESS
          })
          .catch(function (error) {
            context.state.$message.error(
              "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
              3000, "bottom left"
            );
            reject(error)
            console.log(error);
          });
      });
    },
  },
  modules: {
  }

});
export default store
import VueNumerals from 'vue-numerals';

import 'animate.css';
Vue.use(require('vue-moment'));
Vue.use(VueNumerals); // default locale is 'en'
Vue.use(FishUI)

Vue.filter('toHHmm', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  return ("0" + Math.floor(value / 60)).slice(-2) + "h" + ("0" + value % 60).slice(-2);
});

Vue.filter('toNumber', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

router.beforeEach((to, from, next) => {
  // if (to.path != "/Login") {
  //   if (localStorage.getItem("isLogin") == "true") {
  //     next()
  //   }
  //   else next("/Login")
  // }
  // else {
  //   if (localStorage.getItem("isLogin") == "true") {
  //     next({ name: "Today", path: "/" })
  //   }
  //   else
  next()
  // }
})
Vue.config.productionTip = false
new Vue({
  router,
  store: store,
  created() {
    // store.commit("Set_Message", this.$message)
    // store.commit("Set_isLogin", localStorage.getItem("isLogin"));
    // console.log(localStorage.getItem("isLogin"))
    // console.log(localStorage.getItem("oUser"))
    // store.commit("Set_oUser", { oUser: JSON.parse(localStorage.getItem("oUser")) });
    // store.dispatch("API_Getinfo")
  },
  mounted() {
  },
  // data() {
  //   return {
  //     isLogin: false,
  //   }
  // },
  render: h => h(App),
  actions: {

  }
}).$mount('#app')
